import { FormDownloadLink } from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import submitTransformer from '../config/submit-transformer';
import manifest from '../manifest.json';
import { API_ENDPOINTS } from '../utils/constants';
import { selectPdfDownload } from '../utils/selectors';

const PdfDownloadLink = ({ formConfig }) => {
  const { fullName } = useSelector(selectPdfDownload);

  if (!fullName) return null;

  return (
    <FormDownloadLink
      apiEndpoint={API_ENDPOINTS.downloadPdf}
      formConfig={formConfig}
      fullName={fullName}
      rootUrl={manifest.rootUrl}
      transformer={submitTransformer}
    />
  );
};

PdfDownloadLink.propTypes = {
  formConfig: PropTypes.object,
};

export default PdfDownloadLink;
